import React, {Component} from "react"
import {Entity} from "aframe-react"
import aframe from "aframe"

class ComponentEnity extends Entity {

    constructor(props) {
        super(props)

        console.log(this.el);
    }

    init() {

    }

    update() {

    }

    tick() {

    }

    remove() {

    }

    pause() {

    }

    play() {

    }

}

// aframe.registerComponent("react-component", );

export default ComponentEnity;


// WEBPACK FOOTER //
// ./src/components-aframe/index.js